import {DEFAULT_LOCALE, NUMERIC_DECIMAL_SEPARATOR} from '@fo/shared-types/constants';

const formatDisplayValue = (value: string | number): string => {
  let numberToDisplay = '';

  if (typeof value === 'string' && value !== '') {
    numberToDisplay = parseFloat(value).toLocaleString(DEFAULT_LOCALE);
  }
  if (typeof value === 'number') {
    numberToDisplay = value.toLocaleString(DEFAULT_LOCALE);
  }
  if (typeof value === 'string' && value[value.length - 1] === '.') {
    // allows user to add a decimal at the end of the number, without stoppping the ui
    const cleanNumber = value.slice(0, -1); // 12333. => 12333
    const formattedValue = `${parseFloat(cleanNumber).toLocaleString(DEFAULT_LOCALE)}${NUMERIC_DECIMAL_SEPARATOR}`; // 12333 => 12,333.
    numberToDisplay = formattedValue;
  }
  return numberToDisplay;
};

export default formatDisplayValue;
